
<div class="val-flex-conteneur">
  <kendo-checkbox [(checkedState)]="valeurOui"
                  (checkedStateChange)="ChecBoxOuiChange()"
                  [(checkedState)]="valeurOui">
  </kendo-checkbox>
  <div style="width: 4px;"></div>
  <val-simple-libelle [libelle]="Texte('oui', 'Oui')"></val-simple-libelle>
  <div style="width: 4px;"></div>
  <kendo-checkbox [(checkedState)]="valeurNon"
                  (checkedStateChange)="ChecBoxNonChange()"
                  [(checkedState)]="valeurNon">
  </kendo-checkbox>
  <div style="width: 4px;"></div>
  <val-simple-libelle [libelle]="Texte('non', 'Non')"></val-simple-libelle>
</div>
